import {
    instanceOfCodeType as _instanceOfCodeType,
    CodeType,
    ProblemType,
} from "@openapi";
import { PresetColorType } from "antd/es/_util/colors";
import React from "react";
import { CodeOutlined, AppstoreOutlined, BugOutlined } from "@ant-design/icons";

export function instanceOfCodeType(value: unknown): value is CodeType {
    return _instanceOfCodeType(value);
}

// Helper to convert CodeType to ProblemType for filtering
export function codeTypeToProblemType(codeType: CodeType): ProblemType | null {
    switch (codeType) {
        case CodeType.Logo:
        case CodeType.LogoBlockly:
            return ProblemType.Logo;
        case CodeType.Python:
        case CodeType.PythonBlockly:
        case CodeType.PythonTurtle:
        case CodeType.PythonTurtleBlockly:
        case CodeType.Cpp:
            return ProblemType.Algorithmic;
        case CodeType.Pybricks:
        case CodeType.PybricksBlockly:
            return ProblemType.Pybricks;
        case CodeType.Soldered:
            return ProblemType.Soldered;
        default:
            return null;
    }
}

// Configuration for pretty code type display
export interface CodeTypeConfig {
    label: string;
    icon: React.ReactNode;
    color: string;
}

export const CODE_TYPE_CONFIG: Record<CodeType, CodeTypeConfig> = {
    [CodeType.Logo]: {
        label: "Logo Code",
        icon: <CodeOutlined />,
        color: "#52c41a",
    },
    [CodeType.LogoBlockly]: {
        label: "Logo Blocks",
        icon: <AppstoreOutlined />,
        color: "#52c41a",
    },
    [CodeType.Python]: {
        label: "Python Code",
        icon: <CodeOutlined />,
        color: "#1677ff",
    },
    [CodeType.PythonBlockly]: {
        label: "Python Blocks",
        icon: <AppstoreOutlined />,
        color: "#1677ff",
    },
    [CodeType.PythonTurtle]: {
        label: "Python Turtle Code",
        icon: <BugOutlined />,
        color: "#722ed1",
    },
    [CodeType.PythonTurtleBlockly]: {
        label: "Python Turtle Blocks",
        icon: <AppstoreOutlined />,
        color: "#722ed1",
    },
    [CodeType.PybricksBlockly]: {
        label: "Pybricks Blocks",
        icon: <AppstoreOutlined />,
        color: "#fa8c16",
    },
    [CodeType.Pybricks]: {
        label: "Pybricks Code",
        icon: <CodeOutlined />,
        color: "#fa8c16",
    },
    [CodeType.Cpp]: {
        label: "C++ Code",
        // TODO change
        icon: <CodeOutlined />,
        color: "#1677ff",
    },
    [CodeType.Soldered]: {
        label: "Soldered Code",
        icon: <CodeOutlined />,
        color: "#E0D5FF",
    },
};

export function colorForProblemType(problemType: ProblemType): PresetColorType {
    switch (problemType) {
        case ProblemType.Logo:
            return "green";
        case ProblemType.Algorithmic:
            return "blue";
        case ProblemType.Soldered:
            return "purple";
        case ProblemType.Pybricks:
            return "orange";
    }
}

export function problemTypeDisplayName(
    problemType: ProblemType | null,
): string | null {
    switch (problemType) {
        case ProblemType.Logo:
            return "Logo";
        case ProblemType.Algorithmic:
            return "Algorithmic";
        case ProblemType.Soldered:
            return "Soldered";
        case ProblemType.Pybricks:
            return "Pybricks";
        case null:
            return null;
    }
}

// Convert complexity (1-1000) to stars (1-5)
export function complexityToStars(complexity?: number): number {
    if (!complexity) return 1;
    if (complexity <= 200) return 1;
    if (complexity <= 400) return 2;
    if (complexity <= 600) return 3;
    if (complexity <= 800) return 4;
    return 5;
}
